import React from 'react';
import aca1 from '../images/ACA1.jpeg';
import aca4 from '../images/aca4.jpeg';
import aca2 from '../images/aca2.jpeg';

const containerStyle = {
  backgroundColor: '#249ebdff',
  color: 'white',
  minHeight: '100vh',
  padding: '2rem',
  borderRadius: '8px',
};

function PrimaryAcademic() {
  return (
    <>

      <div style={containerStyle} className="container mt-4">
        <h1>Academics at Highlands Primary School</h1>
        <p>
          At Highlands Primary School, we are committed to providing a comprehensive and inclusive education that nurtures the intellectual, emotional, and social development of each learner. Our curriculum is designed to align with the South African National Curriculum and Assessment Policy Statements (CAPS), ensuring a balanced and progressive learning experience.
        </p>

        <h2>Grade R: Foundation Phase</h2>
        <p>
          In Grade R, learners are introduced to formal education through a play-based approach that fosters curiosity and foundational skills.
        </p>
        <ul>
          <li><strong>Language of Instruction:</strong> English</li>
          <li><strong>Core Subjects:</strong> Mathematics, Life Skills</li>
        </ul>

        <h2>Grade 1–3: Intermediate Phase</h2>
        <p>
          The Intermediate Phase builds upon the foundation laid in Grade R, with an emphasis on literacy, numeracy, and personal development.
        </p>
        <ul>
          <li><strong>Languages:</strong> English (Home Language), Afrikaans (First Additional Language),  (Additional Language)</li>
          <li><strong>Core Subjects:</strong> Mathematics, Life Skills</li>
        </ul>

        <h2>Grade 4–6: Senior Phase</h2>
        <p>
          In the Senior Phase, learners engage with a broader range of subjects, preparing them for the transition to high school.
        </p>
        <ul>
          <li><strong>Languages:</strong> English (Home Language), Afrikaans (First Additional Language), Sepedi (Additional Language)</li>
          <li><strong>Core Subjects:</strong> Mathematics, Natural Sciences and Technology, Social Sciences (History and Geography), Life Skills</li>
        </ul>

        <h3>Language Choices in Senior Phase</h3>
        <p>
          Learners in Grade 4–6 have the opportunity to choose between:
        </p>
        <ul>
          <li><strong>English Home Language</strong> or <strong>Sepedi Home Language</strong></li>
          <li><strong>Afrikaans First Additional Language</strong> or <strong>English First Additional Language</strong></li>
        </ul>
        <p>
          These choices allow learners to develop proficiency in languages that are integral to their cultural and academic growth.
        </p>
      </div>

      {/* Images at the bottom */}
      <div className="container my-5">
        <div className="row text-center">
          <div className="col-md-4 mb-3">
            <img src={aca1} alt="Grade R learners in classroom engaging in activities" className="img-fluid rounded" />
          </div>
          <div className="col-md-4 mb-3">
            <img src={aca4} alt="Students conducting a science experiment" className="img-fluid rounded" />
          </div>
          <div className="col-md-4 mb-3">
            <img src={aca2} alt="Group of Grade 5 students reading books together" className="img-fluid rounded" />
          </div>
        </div>
      </div>

    </>
  );
}

export default PrimaryAcademic;
